import { render } from "./FAQPart.vue?vue&type=template&id=1fea61a5"
import script from "./FAQPart.vue?vue&type=script&lang=js"
export * from "./FAQPart.vue?vue&type=script&lang=js"

import "./FAQPart.vue?vue&type=style&index=0&id=1fea61a5&lang=css"

import exportComponent from "/home/jan/Documents/projects/unity/makler-microsite/vue-form/microsite-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__